export const API_HOST = 'https://us.i.posthog.com';
export const API_KEY = 'phc_YtIJcN9fmoolFHzGDiBhTTMQAYRv6cB7ayo3dRvPpWI';